import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { useProductParams } from '../../hooks/useProductParams';

import {
  $cartState,
  handleSelectProduct,
  handleSelectProductSize,
} from '../../store/models/cart';
import { EProducts } from '../../model/enums';
import { $productsState } from '../../store/models/products';
import { fetchGetAllProductsFx } from '../../store/models/products/effects';
import {
  Grass,
} from '../../model/products/Products.type';
import ProductItemInfoSection from '../../components/ui/ProductDetailsPage/ProductItemInfoSection/ProductItemInfoSection';

import styles from './styles.module.scss';

const ProductDetailsPage = () => {
  let { productType, productSize } = useProductParams();
  const { selectedProductSize } = useUnit($cartState);
  const { grasses, accessories, catnips, catGrassSeeds } = useUnit($productsState);
  const size = selectedProductSize || productSize;

  useEffect(() => {
    fetchGetAllProductsFx();
  }, []);

  useEffect(() => {
    let selectedProducts: Array<{ size: string }> = [];

    switch (productType) {
      case EProducts.grs:
        selectedProducts = grasses;
        break;
      case EProducts.acs:
        selectedProducts = accessories;
        break;
      case EProducts.ctn:
        selectedProducts = catnips;
        break;
      case EProducts.sds:
        selectedProducts = catGrassSeeds;
        break;
      default:
        selectedProducts = [];
        break;
    }

    if (!selectedProductSize && size) {
      const selectedProduct = selectedProducts?.find((pr) => pr.size === size);

      handleSelectProductSize(size);

      if (selectedProduct && productType === EProducts.grs) {
        handleSelectProduct(selectedProduct as Grass);
      }
    }
  }, [size, grasses, accessories, catnips, catGrassSeeds, selectedProductSize, productType]);

  return (
    <div className={styles.productDetailsPage}>
      <div className="container">
        <ProductItemInfoSection />
      </div>
    </div>
  );
};

export default ProductDetailsPage;
